//PACKS
import React, { useState, useEffect } from "react";
import { useSpring, animated } from "react-spring";

//STYLES
import "../styles/missionModal.scss";

export default function MissionModal(props) {
  //STATE
  const [toggle, setToggle] = useState(false);

  //ON PROP CHANGE
  useEffect(() => {
    setToggle(props.toggle);
  }, [props]);

  //ANIMATIONS
  const missionModalAnimation = useSpring({
    from: { opacity: 0, backdropFilter: "blur(0px)" },
    to: {
      opacity: toggle ? 1 : 0,
      backdropFilter: toggle ? "blur(10px)" : "blur(0px)",
    },
  });

  return (
    <animated.div
      style={missionModalAnimation}
      className="missionModalContainer"
    >
      <p>{props.description}</p>
    </animated.div>
  );
}
